import store from '@/state/store'

export default class FilterJsonMiddleware
{
    constructor(data){
        this.user = store.getters['auth/getUser']
        this.data = data

        //transform function name call to permission check.
        this.func = {
            one: 'hasPermission',
            any: 'hasAnyPermission',
            all: 'hasAllPermissions',
        }
        this.process()
    }

    process(){
        if(!store.getters['auth/loggedIn']){
            this.data = {};
            return;
        }

        for(const prop in this.data){
            const item = this.data[prop]

            if(item.hasOwnProperty('permission'))
                !this.checkPermissions(item.permission.filter, item.permission.values) && delete(this.data[prop])

            if(this.data.hasOwnProperty(prop) && item.subItems !== undefined && item.subItems.length > 0){
                let temp = []
                for(const subProp in item.subItems){
                    const subItem = item.subItems[subProp]
                    
                    if(subItem.hasOwnProperty('permission'))
                        this.checkPermissions(subItem.permission.filter, subItem.permission.values) && temp.push(subItem)
                    else temp.push(subItem)
                }
                this.data[prop].subItems = temp
            }
        }
        this.data = Object.values(this.data)
    }

    checkPermissions(type, permission){
        return this.user[this.func[type]](permission)
    }
}